<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(8819 14341)">
      <g transform="translate(-8817.667 -14339.667)">
        <path
          d="M9.667,16.333A6.667,6.667,0,1,0,3,9.667,6.667,6.667,0,0,0,9.667,16.333Z"
          transform="translate(-3 -3)"
          fill="none"
          :stroke="props.colorFill"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
          :style="{ fill: 'none !important' }"
        />
        <path
          d="M13.444,9,9,13.444"
          transform="translate(-4.556 -4.556)"
          fill="none"
          :stroke="props.colorFill"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
          :style="{ fill: 'none !important' }"
        />
        <path
          d="M13.444,13.444,9,9"
          transform="translate(-4.556 -4.556)"
          fill="none"
          :stroke="props.colorFill"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
          :style="{ fill: 'none !important' }"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconCircleXmark",

  props: {
    size: { type: [String, Number], default: "16px" },
    colorFill: { type: String, default: "#fb1f1f" },
  },
};
</script>
